import { State } from './types';
export function getInitialState<T extends {}>(): State<T> {
  return {
    isToggelOpen: false,
    openDialog: undefined,
    data: {} as T
  };
}
